import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import {type AxiosResponse} from 'axios';
import {type ApplicationContextInterface} from '@@/package/application/applicationContext';
import ContactApi from "~~/package/apis/contact/ContactApi";
import {ContactModel} from "~~/package/mapper/contact/model/ContactModel";
import type CustomResponse from "~~/package/types/ResponseType";

export default class ContactMapper {
    protected contactApi: ContactApi;

    constructor(context: ApplicationContextInterface) {
        this.contactApi = context.getService<ContactApi>(DependencyInjectId.ContactApi);
    }

    public async submitContactData(request: ContactModel): Promise<boolean> {
        const response: CustomResponse<boolean> = (await this.contactApi.submitContactData(request)).data;
        return response.data
    }
}
